import { render, staticRenderFns } from "./ShowPendingRequestPage.vue?vue&type=template&id=67bba67c"
import script from "./ShowPendingRequestPage.vue?vue&type=script&lang=js"
export * from "./ShowPendingRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports